import {merge} from 'lodash';

import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {KEYPHRASE_ID, KEYWORD_POINTS} from '@axyseo/const/analysis';

/**
 * Represents the Slug keyword assessment. This assessment checks if the keyword is present in the slug.
 */
class KeyphraseAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object} config   The configuration to use.
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: KEYPHRASE_ID,
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#missing-main-keyword',
      ctaType: 'fix',
      fixPosition: 'keyword search',
      priority: 'high',
      title: 'Missing main keyword',
      content: {
        improve: '',
        bad: 'Main keyword field is empty. Add a 2-5 word primary keyword.',
        good: 'Main keyword set'
      }
    };

    this.identifier = KEYPHRASE_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Executes the Assessment and returns a result.
   *
   * @param {Paper}       paper       The Paper object to assess.
   * @param {Researcher}  researcher  The Researcher object containing all available researches.
   *
   * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
   */
  getResult({paper, researcher}) {
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(paper);

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);
    return assessmentResult;
  }

  /**
   * Checks whether the paper has a keyword and a slug.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher object.
   *
   * @returns {boolean} True if the paper contains a keyword and a slug, and if the keywordCountInSlug research is available on the researcher.
   */
  isApplicable(paper, researcher) {
    return true;
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: (string)}}
   */
  calculateResult(paper) {
    const status = (() => {
      let status = 'bad';
      const hasKeyphrase = paper.hasKeyword();
      if (hasKeyphrase) {
        status = 'good';
      }
      return status;
    })();

    const score = this.getScore(KEYWORD_POINTS, status);

    return {
      score,
      status
    };
  }
}

export default KeyphraseAssessment;
